import React, { useContext, useMemo, useState, useRef, useCallback } from "react";
import { Row, Modal } from "reactstrap";
import { useNavigate } from "react-router-dom";
import TableSimple from "../../../components/Dynamic/TableSimple";
import ModalIframePage from "../../../components/Common/ModalIframePage";
import { DF_LO0020Context } from "../context";
import { DF_LO0021Context } from "../DF_LO0021/context";
import DF_LO0021GridBody from "../DF_LO0021/Grid/GridBody"; // criar
import DF_LO0022 from "../DF_LO0022/Grid/GridBody"; // editar
import DF_LO0023 from "../DF_LO0023/Grid/GridBody"; // visualizar
import DF_LO0024 from "../DF_LO0024/Grid/GridBody"; // ativar/desativar
import DF_LO0025 from "../DF_LO0025/Grid/GridBody"; // timeline

export default function GridBody() {
  const {
    userProfile,
    paramsOnFilter,
    triggerOnFilter,
    setTriggerOnFilter,
    inputGlobalSearchValue,
    setFilteredData,
    isOpenModalNuevo,
    setIsOpenModalNuevo,
  } = useContext(DF_LO0020Context);

  const navigate = useNavigate();

  const [triggerType, setTriggerType] = useState(null);
  const [openModalVisualization, setOpenModalVisualization] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);

  const filteredDataRef = useRef([]);

  const handleFilteredDataChange = useCallback(
    (data) => {
      filteredDataRef.current = data || [];
      setFilteredData(data);
    },
    [setFilteredData],
  );

  const handleCloseModalVisualization = useCallback(() => {
    setOpenModalVisualization(false);
    setTriggerType(null);
    setSelectedRowData(null);
  }, []);

  const handleTriggers = useCallback((trigger) => {
    let rowId = null;
    let ativoFromParams = null;
    if (trigger?.params) {
      const matchId = trigger.params.match(/ID_Tabela_Frete=(\d+)/);
      if (matchId) rowId = matchId[1];
      const matchAtivo = trigger.params.match(/Ativo=([SN])/);
      if (matchAtivo) ativoFromParams = matchAtivo[1];
    }
    if (rowId == null) {
      rowId = trigger?.key ?? trigger?.id ?? trigger?.row_id ?? trigger?.ID_Tabela_Frete ?? null;
    }

    const rowData =
      rowId != null
        ? filteredDataRef.current?.find(
            (row) => String(row.ID_Tabela_Frete) === String(rowId),
          )
        : null;
    const txn = trigger?.transaction_id || "";
    const isDirectRender =
      txn.includes("DF_LO0022") ||
      txn.includes("DF_LO0023") ||
      txn.includes("DF_LO0024") ||
      txn.includes("DF_LO0025");

    if (isDirectRender) {
      const rowDataWithAtivo = { ...rowData, Ativo: ativoFromParams ?? rowData?.Ativo ?? rowData?.Status };
      setSelectedRowData(rowDataWithAtivo);
      setTriggerType(trigger);
      setOpenModalVisualization(true);
      return;
    }
    setTriggerType(trigger);
    setOpenModalVisualization(true);
  }, []);

  const handleCancelSuccess = useCallback(() => {
    handleCloseModalVisualization();
    setTriggerOnFilter(true);
  }, [handleCloseModalVisualization, setTriggerOnFilter]);

  const handleCloseNoReload = useCallback(() => {
    handleCloseModalVisualization();
  }, [handleCloseModalVisualization]);

  const handleCloseModalNuevo = useCallback(() => {
    setIsOpenModalNuevo(false);
  }, [setIsOpenModalNuevo]);

  const handleSavedRota = useCallback(() => {
    setIsOpenModalNuevo(false);
    setTriggerOnFilter(true);
  }, [setIsOpenModalNuevo, setTriggerOnFilter]);

  const columnsList = useMemo(
    () => [
      { field: "Status", header: "Status", width: "5%", hasImage: true, Export: false },
      { field: "Transportadora", header: "Transportadora", hasImage: true, sort: true },
      { field: "Fornecedor", header: "Fornecedor", hasImage: true, sort: true },
      { field: "Municipio_Origem", header: "Origem", sort: true },
      { field: "UF_Origem", header: "UF", width: "5%", sort: true },
      { field: "Destino", header: "Destino", hasImage: true, sort: true },
      { field: "UF_Destino", header: "UF", width: "5%", sort: true },
      { field: "Vigencia", header: "Vigência", sort: true },
      { field: "Coluna_Funcoes", header: "", width: "6%", hasImage: true, Export: false },
    ],
    [],
  );

  const txn = triggerType?.transaction_id || "";
  const isAtivarDesativar = txn.includes("DF_LO0024");
  const isEditar = txn.includes("DF_LO0022");
  const isVisualizar = txn.includes("DF_LO0023");
  const isTimeline = txn.includes("DF_LO0025");
  const rotaFormContextValue = useMemo(
    () => ({ userProfile, navigate }),
    [userProfile, navigate],
  );
  const modalTitle = isEditar
    ? "Editar rota"
    : isVisualizar
      ? "Visualizar rota"
      : isTimeline
        ? "Histórico do Documento"
        : "";

  const isDirectRender = isAtivarDesativar || isEditar || isVisualizar || isTimeline;

  const renderDirectModal = () => {
    let content = null;
    if (isAtivarDesativar) {
      content = (
        <DF_LO0024
          rowData={selectedRowData}
          onClose={handleCloseNoReload}
          onCancelSuccess={handleCancelSuccess}
        />
      );
    } else if (isEditar) {
      content = (
        <DF_LO0021Context.Provider value={rotaFormContextValue}>
          <DF_LO0022
            ID_Tabela_Frete={selectedRowData?.ID_Tabela_Frete}
            onClose={handleCloseNoReload}
            onSaved={handleCancelSuccess}
          />
        </DF_LO0021Context.Provider>
      );
    } else if (isVisualizar) {
      content = (
        <DF_LO0021Context.Provider value={rotaFormContextValue}>
          <DF_LO0023
            ID_Tabela_Frete={selectedRowData?.ID_Tabela_Frete}
            onClose={handleCloseNoReload}
          />
        </DF_LO0021Context.Provider>
      );
    } else if (isTimeline) {
      content = (
        <DF_LO0025
          ID_Tabela_Frete={selectedRowData?.ID_Tabela_Frete}
          onClose={handleCloseNoReload}
        />
      );
    }
    return content;
  };

  return (
    <React.Fragment>
      <Row>
        <TableSimple
          dataKey={"ID_Tabela_Frete"}
          procName={"FRONT_Workspace_DF_LO0020_Tabela_Grid_V16"}
          procParams={`[
            "${userProfile?.ID_Usuario || 0}",
            "pt-BR",
            1,
            9999,
            "<#Filtro_Vigencia_De#>",
            "<#Filtro_Vigencia_Ate#>",
            "<#Filtro_ID_Transportadora#>",
            "<#Filtro_UF_Origem#>",
            "<#Filtro_Municipio_Origem#>",
            "<#Filtro_ID_Fornecedor#>",
            "<#Filtro_UF_Destino#>",
            "<#Filtro_Municipio_Destino#>",
            "<#Filtro_ID_Revenda#>",
            "<#Filtro_Status#>",
            "${inputGlobalSearchValue || ""}"
          ]`}
          columnsList={columnsList}
          inputSearchValue={inputGlobalSearchValue}
          callbackTriggers={handleTriggers}
          enableDataSharing={true}
          onFilteredDataChange={handleFilteredDataChange}
          triggerOnFilter={triggerOnFilter}
          setTriggerOnFilter={setTriggerOnFilter}
          paramsOnFilter={paramsOnFilter}
          enableMinHeight={true}
        />

        {isDirectRender ? (
          <Modal
            className={`modal-dialog-centered ${isAtivarDesativar ? "modal-custom-style rounded" : "modal-direct-render"} ${isTimeline ? "type-VIEW_TIMELINE" : ""}`}
            isOpen={openModalVisualization}
            toggle={handleCloseModalVisualization}
            centered
            size={isTimeline ? "xl" : "lg"}
            style={isTimeline ? { maxWidth: 1100 } : isEditar || isVisualizar ? { maxWidth: 900 } : isAtivarDesativar ? { maxWidth: 450 } : {}}
          >
            {!isAtivarDesativar && (
              <div className="modal-header d-flex align-items-center justify-content-between">
                <h5
                  className="modal-title mt-0 font-size-24 font-w-600 text-color-azul1"
                  id="myModalLabel"
                >
                  {modalTitle}
                </h5>
                <button
                  type="button"
                  onClick={handleCloseModalVisualization}
                  className="btn border-0 p-0"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="fas fa-times font-size-24 text-gray-secundary"></i>
                </button>
              </div>
            )}
            <div className="modal-body" style={{ padding: "16px 24px 24px 24px" }}>
              {renderDirectModal()}
            </div>
          </Modal>
        ) : (
          /* Modal genérico para demais triggers */
          <ModalIframePage
            openModal={openModalVisualization}
            onClosed={(isReloadPage) => {
              if (isReloadPage) setTriggerOnFilter(true);
              setOpenModalVisualization(false);
              setTriggerType(null);
            }}
            triggerType={triggerType}
          />
        )}

        {/* Modal "Criar nova rota" — renderizado direto (sem iframe) */}
        <Modal
          className="modal-dialog-centered modal-direct-render"
          isOpen={isOpenModalNuevo}
          toggle={handleCloseModalNuevo}
          centered
          size="lg"
          style={{ maxWidth: 900 }}
        >
          <div className="modal-header d-flex align-items-center justify-content-between">
            <h5
              className="modal-title mt-0 font-size-24 font-w-600 text-color-azul1"
              id="myModalLabel"
            >
              Criar nova rota
            </h5>
            <button
              type="button"
              onClick={handleCloseModalNuevo}
              className="btn border-0 p-0"
              data-dismiss="modal"
              aria-label="Close"
            >
              <i className="fas fa-times font-size-24 text-gray-secundary"></i>
            </button>
          </div>
          <div className="modal-body" style={{ padding: "16px 24px 24px 24px" }}>
            <DF_LO0021Context.Provider value={rotaFormContextValue}>
              <DF_LO0021GridBody
                onClose={handleCloseModalNuevo}
                onSaved={handleSavedRota}
              />
            </DF_LO0021Context.Provider>
          </div>
        </Modal>
      </Row>
    </React.Fragment>
  );
}